import React, { Component } from 'react';
import Axios from "axios";
import AppUrl from "../AppUrl/ApiUrl";
import Menu from "../components/Menu";
import Loading from "../components/Loading";
import NotImg from "../images/404.png";
import { Link } from "react-router-dom";
import Payments from "../components/user/Payments";
import BalanceAdjustUser from "../components/user/BalanceAdjustUser";

class UserDetails extends Component {
    constructor({ match }) {
        super();
        this.state = {
            token: "", name: "", username: "", email: "",
            id: match.params.id, status: "", usertype: "",
            role: [{ name: "Admin" }, { name: "Manager" }, { name: "User" }], user_id: "",
            loading: true, path: "payments", uuid: "", balance: "0", package: "0",
            myrefcode: "", refer_by: "", refcount: "", spin_count: "0", ads_count: "0", claim: "No", created_at: ""
        }
    }

    componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });
        const form = new FormData();
        form.append("token", token);
        form.append("id", this.state.id);

        Axios.post(AppUrl.baseurl + "oneuser", form)
            .then(res => {
                if (!res.data.error && res.data.length > 0) {
                    var val = res.data[0];
                    this.setState({
                        user_id: val["user_id"], name: val["name"], balance: val["balance"], package: val["package"],
                        uuid: val["id"], email: val["email"], status: val["status"],
                        myrefcode: val["myrefcode"], refer_by: val["refer_by"], refcount: val["refcount"],
                        spin_count: val["spin_count"], ads_count: val["ads_count"], claim: val["claim"],
                        created_at: val["created_at"], usertype: val["usertype"], loading: false
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ loading: false });
            });
    }

    onReportChange = (name) => {
        this.setState({ path: name });
    }

    render() {
        const { loading, name, email, id, status, usertype, balance, package: userPackage,
            myrefcode, refer_by, ads_count, spin_count, claim, created_at, image, path, user_id } = this.state;

        return (
            <Menu title={name || "User Details"}>
                <div className="container-fluid py-2">

                    {loading ? (
                        <Loading />
                    ) : (
                        <>
                            {/* Profile Ebong Overview Section */}
                            <div className="row d-flex align-items-stretch">

                                {/* Profile Card */}
                                <div className="col-lg-4 col-md-5 mb-3">
                                    <div className="card border-0 shadow-sm rounded-lg text-center px-3 py-3 bg-white h-100 d-flex flex-column justify-content-between">
                                        <div>
                                            <div className="mb-2 position-relative d-inline-block">
                                                <img
                                                    src={image ? AppUrl.photoUrl + image : NotImg}
                                                    alt={name}
                                                    className="rounded-circle shadow-sm"
                                                    style={{ width: "90px", height: "90px", objectFit: "cover", border: "3px solid #f8f9fa" }}
                                                />
                                            </div>
                                            <h5 className="font-weight-bold mb-1" style={{ fontSize: "18px" }}>{name}</h5>
                                            <p className="text-muted small mb-2">{email}</p>

                                            {/* Type & Status */}
                                            <div className="d-flex justify-content-center align-items-center mb-2" style={{ gap: "8px" }}>
                                                <span style={{
                                                    backgroundColor: "#e8f0fe",
                                                    color: "#1a73e8",
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    padding: "4px 10px",
                                                    borderRadius: "15px"
                                                }}>
                                                    {usertype || "User"}
                                                </span>

                                                <span style={{
                                                    backgroundColor: status?.toLowerCase() === 'active' ? '#e6f4ea' : '#fef7e0',
                                                    color: status?.toLowerCase() === 'active' ? '#137333' : '#b06000',
                                                    fontWeight: "600",
                                                    fontSize: "12px",
                                                    padding: "4px 10px",
                                                    borderRadius: "15px"
                                                }}>
                                                    {status || "Pending"}
                                                </span>
                                            </div>

                                            {/* Edit Profile Button */}
                                            <div className="mb-2">
                                                <Link className="btn btn-outline-primary btn-sm px-3 rounded-pill" to={"/user/edit/" + id} style={{ fontSize: "12px" }}>
                                                    <i className="fa fa-edit mr-1"></i> Edit Profile
                                                </Link>
                                            </div>

                                            <hr className="my-2" />
                                        </div>

                                        <div>
                                            {/* Balance Highlights */}
                                            <div className="bg-light p-2 rounded-lg mb-2">
                                                <span className="text-muted small d-block mb-1">Available Balance</span>
                                                <h3 className="text-success font-weight-bold m-0" style={{ fontSize: "22px" }}>
                                                    ${parseFloat(balance || 0).toFixed(2)}
                                                </h3>
                                            </div>

                                            <div className="text-center small text-muted">
                                                <p className="mb-1"><b>User ID:</b> {id}</p>
                                                <p className="mb-0"><b>Joined Date:</b> {created_at}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Info Cards Grid */}
                                <div className="col-lg-8 col-md-7 mb-3">
                                    <div className="card border-0 shadow-sm rounded-lg p-3 bg-white h-100 d-flex flex-column justify-content-between">
                                        <h6 className="font-weight-bold text-dark border-bottom pb-2 mb-2">Account Overview</h6>

                                        <div className="row flex-grow-1 d-flex align-items-center">
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Current Package</small>
                                                    <strong className="text-dark">Plan: {userPackage}</strong>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Referral Code</small>
                                                    <strong className="text-primary">{myrefcode || "N/A"}</strong>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Referred By</small>
                                                    <strong className="text-dark">{refer_by || "None"}</strong>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Claim Status</small>
                                                    <strong className={claim === "Yes" ? "text-success" : "text-danger"}>{claim}</strong>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Ads Watched</small>
                                                    <strong className="text-dark">{ads_count}</strong>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                                <div className="p-2 border rounded bg-light">
                                                    <small className="text-muted d-block">Spin Completed</small>
                                                    <strong className="text-dark">{spin_count}</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Full Width Payments & Balance Section */}
                            <div className="row mt-1">
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm rounded-lg bg-white overflow-hidden">
                                        <div className="card-header bg-white border-bottom-0 p-0">
                                            <ul className="nav nav-tabs border-bottom pl-3">
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link border-0 py-3 px-4 font-weight-bold ${path === "payments" ? "active border-bottom border-primary text-primary" : "text-muted"}`}
                                                        onClick={() => this.onReportChange("payments")}
                                                        style={{ background: "none", cursor: "pointer" }}
                                                    >
                                                        <i className="fa fa-credit-card mr-2"></i> Payments
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link border-0 py-3 px-4 font-weight-bold ${path === "balance" ? "active border-bottom border-primary text-primary" : "text-muted"}`}
                                                        onClick={() => this.onReportChange("balance")}
                                                        style={{ background: "none", cursor: "pointer" }}
                                                    >
                                                        <i className="fa fa-wallet mr-2"></i> Balance Adjustment
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="card-body p-3">
                                            {path === "payments" && <Payments uid={id} />}
                                            {path === "balance" && <BalanceAdjustUser user_id={user_id} uid={id} email={email} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Menu>
        );
    }
}

export default UserDetails;